/* Two independent fingerprint files, submitted by OwnPrint's existing multipart upload path. */
(() => {
  'use strict';
  const rootSelector = '[data-ownprint-personalization]:not([data-ownprint-duplicate="1"])';
  const savedFiles = new Map();
  const isFingerprintPage = () => window.location.pathname.includes('/products/personalized-fingerprint-heart-necklace-with-birthstone');

  function restoreFile(input, number) {
    const file = savedFiles.get(number);
    if (file && !input.files?.length && typeof DataTransfer !== 'undefined') {
      try {
        const transfer = new DataTransfer();
        transfer.items.add(file);
        input.files = transfer.files;
      } catch (_) { /* If restoration is unsupported, validation requires a fresh selection. */ }
    }
  }

  function configure(input, number) {
    input.name = `properties[Fingerprint ${number}]`;
    input.dataset.shunovaFingerprint = String(number);
    input.multiple = false;
    input.required = true;
    input.setAttribute('aria-required', 'true');
    const field = input.closest('.ownprint-personalization__field');
    const label = field?.querySelector('label');
    if (label) {
      label.htmlFor = input.id;
      label.textContent = `Fingerprint ${number}`;
      const required = document.createElement('span');
      required.className = 'ownprint-personalization__required';
      required.setAttribute('aria-hidden', 'true');
      required.textContent = ' *';
      label.append(required);
    }
    const instructions = field?.querySelector('.ownprint-personalization__instructions:not(.ownprint-personalization__instructions--hint)');
    if (instructions) instructions.textContent = `Upload the ${number === 1 ? 'first' : 'second'} person's fingerprint image.`;
    restoreFile(input, number);
  }

  function prepare() {
    if (!isFingerprintPage()) return null;
    const root = document.querySelector(rootSelector);
    if (!root) return null;
    const pair = root.querySelectorAll('input[data-shunova-fingerprint]');
    if (pair.length === 2) {
      pair.forEach(input => restoreFile(input, Number(input.dataset.shunovaFingerprint)));
      return root;
    }

    // Respect a pair already configured in OwnPrint rather than creating four fields.
    const first = root.querySelector('input[type="file"][name="properties[Fingerprint 1]"]');
    const second = root.querySelector('input[type="file"][name="properties[Fingerprint 2]"]');
    if (first && second) {
      configure(first, 1);
      configure(second, 2);
      return root;
    }

    const original = root.querySelector('input[type="file"][data-ownprint-file][name="properties[Upload Your Fingerprints]"]');
    const field = original?.closest('.ownprint-personalization__field');
    if (!original || !field) return root;
    const secondField = field.cloneNode(true);
    const secondInput = secondField.querySelector('input[type="file"]');
    secondInput.id = `${original.id}-fingerprint-2`;
    configure(original, 1);
    configure(secondInput, 2);
    field.after(secondField);
    return root;
  }

  function errorBox(root) {
    let box = root?.querySelector('[data-shunova-fingerprint-error]');
    if (box) return box;
    const anchor = root?.querySelector('input[data-shunova-fingerprint="2"]')?.closest('.ownprint-personalization__field')
      || document.querySelector('#MainContent product-form-component');
    if (!anchor) return null;
    box = document.createElement('p');
    box.dataset.shunovaFingerprintError = '';
    box.className = 'ownprint-personalization__error';
    box.setAttribute('role', 'alert');
    box.hidden = true;
    anchor.append(box);
    return box;
  }

  function productPurchase(event) {
    if (!isFingerprintPage()) return false;
    const target = event.target;
    if (!(target instanceof Element)) return false;
    if (event.type === 'submit') return target.matches('form[action*="/cart/add"]');
    const main = document.querySelector('#MainContent');
    if (!main?.contains(target)) return false;
    if (target.closest('.shopify-payment-button, shopify-accelerated-checkout, [data-shopify="payment-button"]')) return true;
    const button = target.closest('[name="add"], button[type="submit"], input[type="submit"], [data-add-to-cart], .product-form__submit');
    if (!button || button.matches('[name="checkout"]')) return false;
    const form = button.closest('form') || (button.getAttribute('form') && document.getElementById(button.getAttribute('form')));
    return !!(form?.matches('form[action*="/cart/add"]') || button.closest('product-form-component'));
  }

  function validate(event) {
    if (!productPurchase(event)) return;
    const root = prepare();
    const inputs = root ? Array.from(root.querySelectorAll('input[data-shunova-fingerprint]')) : [];
    const missing = inputs.find(input => input.disabled || input.files?.length !== 1);
    if (inputs.length === 2 && !missing) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const box = errorBox(root);
    if (box) {
      box.textContent = missing
        ? `Please upload Fingerprint ${missing.dataset.shunovaFingerprint}. Both fingerprint images are required.`
        : 'The fingerprint upload fields are unavailable. Please refresh this page before adding this necklace.';
      box.hidden = false;
    }
    missing?.focus();
    missing?.reportValidity();
  }

  // The early inline guard invokes this function before OwnPrint's capture handler.
  window.shunovaValidateFingerprintUploads = validate;
  document.addEventListener('change', event => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.dataset.shunovaFingerprint) return;
    const number = Number(input.dataset.shunovaFingerprint);
    if (input.files?.[0]) savedFiles.set(number, input.files[0]);
    else savedFiles.delete(number);
    const box = input.closest(rootSelector)?.querySelector('[data-shunova-fingerprint-error]');
    if (box) box.hidden = true;
  }, true);
  const observer = new MutationObserver(prepare);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', prepare, { once: true });
  document.addEventListener('shopify:section:load', prepare);
  prepare();
})();
